<template>
    <div
        id="side"
        class="sticky width25 paddingleft20"
        :class="{ ipadsticky: ipadSticky }"
    >
        <div
            id="cruise-overzicht"
            class="width100"
            style="background-color: rgb(255, 255, 255);"
        >
            <div :class="rederijLogo"></div>

            <div class="cruise-info">
                <div v-if="cruise.titel" class="regel rederijoverzicht">
                    <span
                        class="width100 floatleft bold uppercase font10 midblauw"
                        v-html="cruise.titel"
                    ></span>
                    <span
                        class="width100 floatleft bold font10 midblauw"
                        v-html="
                            'met de ' + cruise.schip_naam + ' ' + cruiseTitle
                        "
                    ></span>
                </div>
            </div>
            <div class="clear"></div>

            <div id="package_inclusief_segmenten"></div>

            <div class="cruise-info">
                <div class="regel">
                    <span class="marginright5 floatleft bold"
                        >Cruise code:</span
                    >
                    <span v-if="cruiseCode" class="floatleft">
                        {{ cruiseCode }}
                    </span>
                </div>

                <div class="regel">
                    <span class="marginright5 floatleft bold"
                        >Vertrekdatum:</span
                    >
                    <span v-if="departureDate" class="floatleft">
                        {{ safeDateFormat(departureDate) }}
                    </span>
                </div>

                <div class="regel">
                    <span class="marginright5 floatleft bold"
                        >Terugkomstdatum:</span
                    >
                    <span v-if="departureDate" class="floatleft">
                        {{ safeDateFormat(departureDate, cruise.duur - 1) }}
                    </span>
                </div>

                <div v-for="index in cabinCount">
                    <SideBarCabin :index="index - 1" />
                </div>
            </div>
            <div class="clearfix"></div>

            <div
                style="margin-top: -20px;"
                class="cruise-prijzen"
                id="boekingsoverzicht"
            >
                <div id="prijsoverzicht_dranken"></div>

                <div v-if="fooienTotaal > 0" class="fooien">
                    <span class="width58 floatleft">Fooien/Services</span>
                    <span class="variabel width38 textright floatright"
                        >€ {{ roundPrice(fooienTotaal) }}</span
                    >
                </div>

                <div v-if="verzorgingTotaal > 0" class="fooien">
                    <span class="width58 floatleft"
                        >Verzorging All-inclusive</span
                    >
                    <span class="variabel width38 textright floatright"
                        >€ {{ roundPrice(verzorgingTotaal) }}</span
                    >
                </div>

                <div v-if="flightTotaal > 0" class="fooien">
                    <span class="width58 floatleft">Vluchten</span>
                    <span class="variabel width38 textright floatright"
                        >€ {{ roundPrice(flightTotaal) }}</span
                    >
                </div>

                <div class="prijsoverzicht_segmenten displaynone">
                    <div class="width100 prijsoverzicht_segment_titel_vluchten">
                        <span
                            class="width5 floatleft vluchticon-img zoom70 marginright5 margintop5"
                        ></span>
                        <span class="bold uppercase width50">Vluchten</span>
                    </div>
                    <div id="prijsoverzicht_vluchten"></div>
                    <div class="clear height10"></div>

                    <div
                        class="width100 prijsoverzicht_segment_titel_transfers"
                    >
                        <span
                            class="width5 floatleft transfericon-img zoom70 marginright5 margintop5"
                        ></span>
                        <span class="bold uppercase width50">Transfers</span>
                    </div>
                    <div id="prijsoverzicht_transfers"></div>
                    <div class="clear height10"></div>
                </div>

                <div v-if="totalPrice > 0" class="calamiteiten">
                    <span class="width58 floatleft">Calamiteitenfonds</span>
                    <span class="variabel width38 textright floatright"
                        >€ {{ roundPrice(calamiteitenFonds) }}</span
                    >
                </div>

                <div v-if="totalPrice > 0" class="sgrfonds">
                    <span class="width58 floatleft">SGR fonds</span>
                    <span class="variabel width38 textright floatright"
                        >€ {{ roundPrice(sgrFonds) }}</span
                    >
                </div>

                <div class="administratie">
                    <span class="width58 floatleft">Administratiekosten</span>
                    <span class="variabel width38 textright floatright"
                        >€ 0,-</span
                    >
                </div>
                <div class="clear"></div>
            </div>
            <div class="clear"></div>

            <div class="totaal margintop10 paddingtop20">
                <div class="width100">
                    <span class="midblauw floatleft font18 width30 bold"
                        >Totaal</span
                    >
                    <span
                        class="midblauw floatright font22 textright width60 bold"
                        id="boekingsoverzicht_totaalprijs"
                        >€ {{ totalPrice }},-</span
                    >
                </div>
                <div class="persoon prijs_pp">
                    <span class="width58 floatleft">Prijs per persoon</span>
                    <span
                        class="variabel width38 textright floatright"
                        id="boekingsoverzicht_pp"
                        >€ {{ roundPrice(pricePerPax) }}</span
                    >
                </div>
            </div>

            <div
                v-if="showBoeken"
                class="meldingen_book displaynone_mobile"
                style="display: block;"
            >
                <div
                    class="width100 floatleft font12 bold margintop10 textcenter"
                    style="color: #f39c12!important;"
                >
                    <font-awesome-icon
                        icon="check-circle"
                        class="font14 marginright5"
                    />
                    <span class="font12">Online boeken is mogelijk!</span>
                </div>
                <div
                    class="width100 floatleft font12 textcenter"
                    style="color: #f39c12!important;"
                >
                    <span class="font10 textcenter">
                        Klik onderaan de pagina op de oranje knop met "bekijk
                        beschikbare hutten".
                    </span>
                </div>
            </div>
        </div>
        <div class="clear"></div>

        <InExclusive />
        <div class="clear"></div>

        <!--        <BelMe />-->
        <!--        <div class="clear margintop15"></div>-->
        <transition name="fade">
            <div class="totalpricemobile" v-if="isShown">
                <div>
                    <a
                        onclick="$('html, body').animate({scrollTop: $('#cruise-overzicht').offset().top-50}, 1000);"
                    >
                        <span class="font16 bold">
                            <font-awesome-icon icon="info-circle" />
                            Totaal € {{ totalPrice }},-
                        </span></a
                    >

                    <a
                        class="mobilebutton"
                        onclick="$('html, body').animate({scrollTop: $('#formulier-offerte-aanvragen').offset().top-50}, 1000);"
                    >
                        Aanvragen
                    </a>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import BelMe from './BelMe.vue'
import InExclusive from './InExclusive.vue'
import SideBarCabin from './sidebarCabin'

export default {
    name: 'SideBar2',

    components: {
        InExclusive,
        SideBarCabin,
    },
    data: function() {
        return { isShown: true, ipadSticky: false }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll)
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        handleScroll(event) {
            // @todo set offset through data
            let scroll = $(window).scrollTop()

            if (
                $('#cruise-offerte_aanvragen') &&
                $('#cruise-offerte_aanvragen').offset() &&
                scroll >= $('#cruise-offerte_aanvragen').offset().top - 400
            ) {
                // check the offset top
                this.isShown = false
            } else {
                this.isShown = true
            }
            let userAgent = navigator.userAgent.toLowerCase(),
                ios = /ipad/.test(userAgent)
            if (ios && window.innerWidth > 900) {
                if (
                    $('#cruisepagina-content') &&
                    $('#cruisepagina-content').offset() &&
                    scroll >= $('#cruisepagina-content').offset().top
                ) {
                    // check the offset top
                    this.ipadSticky = true
                } else {
                    this.ipadSticky = false
                }
            }
        },

        safeDateFormat: function(date, days = 0, format = 'dd ll') {
            if (date && format) {
                let mom = this.moment(date)
                    .add(days, 'days')
                    .format(format)
                if (mom !== 'Invalid date') {
                    return mom
                }
            }
            return null
        },

        numberWithCommas: function(num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        },

        roundPrice: function(price) {
            if (!price) return '-'
            if (isNaN(price)) return '?'
            let parsed = price.toFixed(2)
            return this.numberWithCommas(
                parsed
                    .split('.')
                    .join(',')
                    .replace(',00', ',-')
            )
        },
    },
    computed: {
        showBoeken: function() {
            return this.$store.getters.showBoeken
        },

        cabinSetup: function() {
            return this.$store.state.cabinSetup
        },

        cabinCount: function() {
            return this.$store.state.cabinCount
        },

        cruise: function() {
            return this.$store.state.cruise
        },

        cruiseTitle: function() {
            let str = this.$store.state.cruise
            if (str.titel_havens) {
                return str.titel_havens.split('langs')[0]
            }
            return ''
        },

        cruiseCode: function() {
            let cruiseID = this.highlightedRate.cruiseID
            let rederijNaam = this.cruise.rederij_naam

            if (cruiseID > 0 && rederijNaam !== null) {
                return (
                    this.cruise.rederij_naam[0] +
                    this.cruise.rederij_id +
                    '-' +
                    cruiseID
                )
            }
            return null
        },

        rederijLogo: function() {
            if (this.cruise && this.cruise.rederij_naam) {
                return (
                    this.cruise.rederij_naam.replace(/\s/g, '-').toLowerCase() +
                    '-small-img'
                )
            }
            return null
        },

        highlightedRate: function() {
            return this.$store.state.highlightedRate
        },

        departureDate: function() {
            return this.$store.getters.highlightedDepartureDate
        },

        calamiteitenFonds: function() {
            return this.$store.state.calamiteitenFonds
        },

        sgrFonds: function() {
            return this.$store.state.sgrFonds
        },

        totalPrice: function() {
            return this.$store.getters.totalPrice
        },

        totalPaxCount: function() {
            return this.$store.getters.totalPaxCount
        },

        pricePerPax: function() {
            return this.totalPrice / this.totalPaxCount
        },

        fooienTotaal: function() {
            return this.$store.getters.fooienTotaal
        },

        verzorgingTotaal: function() {
            return this.$store.getters.verzorgingTotaal
        },

        flightTotaal: function() {
            return this.$store.getters.flightTotaal
        },

        fooienType: function() {
            return this.$store.state.fooienType
        },

        verzorgingType: function() {
            return this.$store.state.verzorgingType
        },
    },
}
</script>

<style scoped lang="scss">
.totalpricemobile {
    div {
        margin: 15px auto;
        width: calc(100% - 60px);
        color: white;
        background: #37b5d3;
        position: relative;
    }
    div a {
        color: white;
    }
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;

    background: #37b5d3;
    z-index: 10;

    border-top: 1px solid white;
    .mobilebutton {
        background: #9dd057;
        color: white;
        padding: 15px;
        border-radius: 5px;
        font-size: 14px;
        text-decoration: none;
        float: right;
        margin-bottom: 15px;
    }
    a:hover {
        text-decoration: none;
    }
    a::after {
        text-decoration: none;
    }
    span {
        margin-top: 17px;
        line-height: 15px;
        float: left;
    }
}
@media screen and (min-width: 900px) {
    .totalpricemobile {
        display: none;
    }
}
div.sticky {
    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: 65px;
}
.ipadsticky {
    position: fixed !important;
    top: 65px;
    right: 0;
}
.cruise-prijzen div {
    min-height: 20px;
}
</style>
